module.exports = __webpack_public_path__ + "static/media/face-with-thermometer-svgrepo-com.1ad0622b.svg";